import {z} from 'zod'

export const BugReportFormSchema = z.object({
    title: z.string().min(1, 'Title is required'),
    description: z.string().optional().default('')
})

export type BugReportFormValues = z.infer<typeof BugReportFormSchema>

export type EnvironmentSnapshot = {
    reporterName: string
    reporterEmail: string
    url: string
    browser: string
    os: string
    screenResolution: string
    viewportSize: string
    appVersion: string
    timestamp: string
}

export type LinearIssuePayload = {
    title: string
    description: string
    teamId: string
    projectId: string
    assigneeId: string
}

export type LinearCreatedIssue = {
    id: string
    identifier: string
    title: string
    url: string
}

export type LinearIssueStateType = 'triage' | 'backlog' | 'unstarted' | 'started' | 'completed' | 'canceled'

export type LinearIssueState = {
    name: string
    color: string
    type: LinearIssueStateType
}

export type LinearIssue = {
    id: string
    identifier: string
    title: string
    description: string | null
    url: string
    createdAt: string
    state: LinearIssueState | null
}
